module.exports = __webpack_public_path__ + "static/media/status-icon.af90a1e1.svg";